import { Button } from "@/components/ui/button";
import { Dialog, DialogPortal, DialogOverlay, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PrimaryButton } from "@/components/ui/PrimaryButton";
import { Loader2 } from "lucide-react";

export const AppModal = ({
  isOpen,
  onOpenChange,
  title = "Title",
  description = "Description",
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  isLoading = false,
  disabled = false,
  onConfirm,
  onCancel,
  footer,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  confirmButtonText?: string | React.ReactNode;
  cancelButtonText?: string | React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  footer?: React.ReactNode;
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(isOpen) => {
        onOpenChange?.(isOpen);
      }}
    >
      <DialogPortal>
        <DialogOverlay className="bg-gradient-to-b from-[#126c74]/50 via-[#a89a5c]/50 to-[#126c74]/50" />
        <div className="fixed left-[50%] top-[36%] z-50 grid w-11/12 max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 rounded-lg">
          <div className="flex flex-col space-y-1.5 text-center sm:text-left">
            <DialogTitle className="text-lg font-semibold leading-none tracking-tight">{title}</DialogTitle>
            <DialogDescription className="text-sm text-muted-foreground">{description}</DialogDescription>
          </div>

          {footer || (
            <footer className="flex gap-y-2 flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
              <Button
                variant="outline"
                onClick={() => {
                  onOpenChange?.(false);
                  onCancel?.();
                }}
                disabled={disabled || isLoading}
              >
                {cancelButtonText}
              </Button>

              <PrimaryButton
                onClick={() => onConfirm?.()}
                className="flex justify-center gap-2 sm:w-auto"
                disabled={disabled || isLoading}
              >
                {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
                {confirmButtonText}
              </PrimaryButton>
            </footer>
          )}
        </div>
      </DialogPortal>
    </Dialog>
  );
};
